<script lang="ts">
	import { cn } from '$lib/shadutils'
	import { badgeVariants, type Variant } from '.'

	let className: string | undefined | null = undefined
	export let href: string | undefined = undefined
	export let variant: Variant = 'default'
	export { className as class }
	export let category = ''
</script>

<svelte:element
	this={href ? 'a' : 'span'}
	{href}
	class={cn(badgeVariants({ variant, className }))}
	{...$$restProps}
	class:shapes={category === 'shapes'}
	class:behaviours={category === 'behaviours'}
	class:utilities={category === 'utilities'}
	class:effects={category === 'effects'}
>
	<slot />
</svelte:element>

<style>
	.shapes {
		@apply bg-[hsl(53,8%,20%)] border-[#DDD273] border-opacity-10;
	}

	.behaviours {
		@apply bg-[hsl(120,8%,20%)] border-[#9DD998] border-opacity-10;
	}

	.utilities {
		@apply bg-[hsl(200,8%,20%)] border-[#A8D3FA] border-opacity-10;
	}

	.effects {
		@apply bg-[hsl(353,8%,20%)] border-[#F5B4B8] border-opacity-10;
	}
</style>
